"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveToMapsLocation = void 0;
var qs_1 = __importDefault(require("qs"));
var dialog_store_1 = __importDefault(require("~/stores/dialog_store"));
var MAPS_LOCATION_PATH = '/maps/locations';
var moveToMapsLocation = function () {
    navigator.geolocation.getCurrentPosition(function (pos) {
        var params = {
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude
        };
        location.href = "".concat(MAPS_LOCATION_PATH, "?").concat(qs_1.default.stringify(params));
    }, function () { return dialog_store_1.default.showDialogWithCloseButton('現在地の取得ができませんでした', ''); });
};
exports.moveToMapsLocation = moveToMapsLocation;
